import React from 'react';
import { isEmpty, map, prop } from 'ramda';
import RoleCardItem from './RoleCardItem';

const RoleCardList = ({ roles, onDelete, isAdministration }) => (
  <>
    <p className="font-bold !mb-3 mt-11">Rôles assignés</p>
    <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto mb-5">
      {isEmpty(roles) && <span className="text-flexi-grey">Aucun rôle assigné</span>}
      {map((role) => <RoleCardItem {...role} onDelete={onDelete && (() => onDelete(prop('uuids', role)))} isAdministration={isAdministration} />, roles)}
    </div>
  </>
);

export default RoleCardList;